const TABLET_BREAKPOINT = 900

// Combines the user's chosen viewMode ('auto' | 'cards' | 'table') with the
// current window width to decide whether cards (vs the table) should render.
export default function useShouldShowCards() {
  const viewMode = useSel(s => s.local.viewMode)
  const [windowWidth, setWindowWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 0)

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth)
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const isMobileWidth = windowWidth <= TABLET_BREAKPOINT
  return viewMode === 'cards' || (viewMode === 'auto' && isMobileWidth)
}
